module.exports = __webpack_public_path__ + "assets/assets/images/icons/logout.2cab0046.svg";


//////////////////
// WEBPACK FOOTER
// ./client/assets/images/icons/logout.svg
// module id = 275
// module chunks = 2